<template>
    <div id="Introduction">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=2></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div>
                <h2 class="app-title">{{ details.title }}</h2>
                <!-- <h6>{{ details.created_at }}</h6> -->
                <video :src="details.image" alt="" class="pic" controls v-if="details.pid == 6"></video>
                <img :src="details.image" alt="" class="pic" v-else>
                <p v-html="details.content"></p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { useRoute } from 'vue-router';
    import { backheadTitles,imageurl} from "../utils/i18nLabels";
    const route = useRoute();
    const isMobile = localStorage.getItem('userAgent')
    const titleLabel = computed(() => backheadTitles.mobileDetails[currentLanguage.value || 'zh'])
    const details = ref({});
    // 获取列表数据
    function getList() {
        let queryParams = {
            id: route.query.id
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            const tdetails = data.list[0] || {}
            tdetails.image = tdetails?.image ? imageurl + tdetails.image : undefined
            tdetails.created_at = tdetails?.created_at !='0001-01-01T00:00:00Z'? tdetails.created_at.slice(0, 4) + '.' + tdetails.created_at.slice(5, 7) + '.' + tdetails.created_at.slice(8, 10) : ""
            details.value = tdetails;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Introduction{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
        padding: 60px;
    }
    .pic{
        width: 50%;
        margin: 0 auto 60px;
        display: block;
    }
    h2{
        font-size: 30px;
        color: #232323;
        font-weight: normal;
        margin-bottom: 30px;
        text-align: center;
    }
    h6{
        font-size: 26px;
        color: #3a3a3a;
        font-weight: normal;
        margin-bottom: 50px;
        text-align: center;
    }
    p{
        width: 50%;
        color: #000;
        line-height: 32px;
        margin: 0 auto 20px;
    }

    .Mobileclass{
        padding: 22px;
        margin-top: 160px;
        .pic{
            width: 100%;
            margin: 0 auto 30px;
        }
        h2{
            font-size: 20px;
            margin-bottom: 10px;
        }
        h6{
            font-size: 16px;
            margin-bottom: 30px;
            text-align: center;
        }
    }
</style>